import { api } from '$app/api';

export const getBookingsToAllocateForGarage = async (startDate, garageId) => {
  const { data } = await api.post('/allocations/garage-focus/bookings', {
    startDate,
    garageId,
  });
  return data;
};
